import upload from '@/utils/upload';

import api from '@/utils/api';

const { baseupload } = window.GlobalConfig;

export const QueryDesignerPage = data => {
    return upload.post(``, data);
};

export const QueryListPage = data => {
    return upload.post(``, data);
};

export const QueryCategoryPage = data => {
    return api.get(`/workflow/category/getFlowCategoryTree`, data);
};

export const QueryCategoryInfo = data => {
    return upload.get(``);
};

export const SaveCategory = data => {
    return api.post(`/workflow/category/addFlowCategory`, data);
};

export const UpdateCategory = data => {
    return api.post(`/workflow/category/updateFlowCategory`, data);
};

export const UpdateSortCategory = data => {
    return upload.post(``, data);
};

export const DeleteCategory = ({ categoryId }) => {
    return api.delete(`/workflow/category/deleteFlowCategory/${categoryId}`);
};

export const QueryComponentCategoryList = () => {
    return upload.get(``);
};

export const QueryDefinitionPage = data => {
    return upload.post(`/workflow/definition/getFlowDefinitionListPage`, data);
};

export const SaveDefinition = data => {
    return api.post(`/workflow/definition/addFlowDefinition`, data);
};

export const UpdateDefinition = data => {
    return api.put(`/workflow/definition/updateFlowDefinition`, data);
};

export const CopyDefinition = ({ id }) => {
    return api.get(`/workflow/definition/addFlowDefinitionByCopy/${id}`);
};

export const PublishDefinition = ({ id }) => {
    return api.put(`/workflow/definition/publish/${id}`);
};

export const DeleteDefinition = ({ id }) => {
    return api.delete(`/workflow/definition/deleteFlowDefinition/${id}`);
};

export const UnPublishDefinition = ({ id }) => {
    return api.put(`/workflow/definition/unPublish/${id}`);
};

export const StartInstance = data => {
    return api.post(`/workflow/instance/startInstance`, data);
};

export const ClearInstance = ({ id }) => {
    return api.get(`${id}`);
};

export const ApplyDevCustomer = data => {
    return api.post(`/workflow/business/customerDevelop/save`, data);
};

export const ApplyDelayCustomer = data => {
    return api.post(`/workflow/business/customerDevelop/save4Delay`, data);
};

export const QueryFlowalbeInfo = () => {
    return api.get(``);
};

export const QueryAgentFlowable = data => {
    return api.post(`/workflow/task/getTaskWaitByCurrentUserPage`, data);
};

export const QueryDoneFlowable = data => {
    return api.post(`/workflow/task/getTaskFinishByCurrentUserPage`, data);
};

export const QueryFlowableState = () => {
    return api.get(`/workflow/instance/getFlowStatusMap`);
};

export const ApprovalPass = data => {
    return api.post(`/workflow/task/updateTaskComplete`, data);
};

export const ApprovalQuit = data => {
    return api.post(`/workflow/task/updateTaskTermination`, data);
};

export const ApprovalReject = data => {
    return api.post(`/workflow/task/updateTaskReject`, data);
};

export const QueryTaskAll = ({ instanceId }) => {
    return api.get(`/workflow/task/getAllTaskByInstance/${instanceId}`);
};

export const QueryHisTask = ({ instanceId }) => {
    return api.get(`/workflow/hisTask/getAllTaskByInstance/${instanceId}`);
};

export const QueryLaunchFlowable = data => {
    return api.post(``, data);
};

export const ApplyFeeMonthOut = data => {
    return api.post(`/workflow/business/expenseStandardCustomerMonth/save`, data);
};

export const AdditionalFee = data => {
    return api.post(`/workflow/business/expenseStandardCustomerMonth/saveAdditional`, data);
};

export const ApplyReimburs = data => {
    return api.post(`/workflow/business/expenseStandardCustomerMonth/saveReimburse`, data);
};

export const QueryTaskList = ({ instanceId }) => {
    return api.get(`/workflow/task/getAllTaskWaitByInsId/${instanceId}`);
};

export const UpdateActiveDefine = ({ id }) => {
    return api.put(`/workflow/definition/updateActive/${id}`);
};

export const UpdateUnActiveDefine = ({ id }) => {
    return api.put(`/workflow/definition/updateUnActive/${id}`);
};
